import React from 'react';

import { useLinkTextToAvoidInJobSearchesState, useLinkTextToAvoidInJobSearchesActions } from './LinkTextToAvoidInJobSearchesContext';

import Table from '../../Shared/UI/Table/components/Table';
import Thead from '../../Shared/UI/Table/components/Thead';
import Tbody from '../../Shared/UI/Table/components/Tbody';
import Tr from '../../Shared/UI/Table/components/Tr';
import Th from '../../Shared/UI/Table/components/Th';
import Td from '../../Shared/UI/Table/components/Td';
import Button from '../../Shared/UI/Button/components/Button';

const LinkTextToAvoidInJobSearchesTable = () => {
  const state = useLinkTextToAvoidInJobSearchesState();
  const { openDeleteLinkTextModal } = useLinkTextToAvoidInJobSearchesActions();

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  const handleDelete = (linkText) => {
    openDeleteLinkTextModal(linkText);
  };

  if (!state?.linkTexts || state.linkTexts.length === 0) {
    return <p>No link text entries found.</p>;
  }

  return (
    <Table>
      <Thead>
        <Tr>
          <Th>Value</Th>
          <Th>Created At</Th>
          <Th>Action</Th>
        </Tr>
      </Thead>
      <Tbody>
        {state.linkTexts.map(linkText => (
          <Tr key={linkText.id}>
            <Td>{linkText.value}</Td>
            <Td>{formatDate(linkText.createdAt)}</Td>
            <Td>
              <Button
                onClick={() => handleDelete(linkText)}
                variant="danger"
              >
                Delete
              </Button>
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
};

export default LinkTextToAvoidInJobSearchesTable;
